export default __webpack_public_path__ + "static/media/org.dc5d0e9e.svg";